<template>
  <v-dialog
    v-model="showShareOpportunityCampaignDialog"
    :retain-focus="false"
    :max-width="500"
    transition="slide-y-transition"
    @click:outside="hideModal"
  >
    <v-card
      class="pa-2 pt-0 pb-0"
      :style="contentStyle"
    >
      <v-container>
        <v-row
          no-gutters
          align="center"
        >
          <v-col class="headline">
            Share an opportunity and partner with Riverflex to earn 40% margin share!*
          </v-col>

          <v-col cols="auto">
            <v-btn
              small
              fab
              icon
              @click="hideModal"
            >
              <v-icon>
                close
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row
          class="my-4"
          no-gutters
        >
          <v-col cols="12">
            <p>
              Post a job opportunity and request support from the Riverflex team. We’ll partner with you to source the best independent consultants for the project and help you win it. When the opportunity has been successfully staffed, you will receive 40% margin share.
            </p>
            <p class="mt-2">
              <i>*Valid only until 31st December 2020</i>
            </p>
            <v-img
              class="mx-auto my-5"
              :src="require('@/assets/images/ui/Platform-popup-40.svg')"
              max-width="50%"
              contain
            />

            <div class="text-center">
              <v-btn
                class="mt-3 d-flex mx-auto"
                color="primary"
                rounded
                light
                @click="handlePostOppClick"
              >
                Post an opportunity now
              </v-btn>

              <v-btn
                class="mt-3 d-flex mx-auto"
                color="primary"
                rounded
                light
                @click="handleEmailClick"
              >
                Email us for support
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import InfoDialog from '@/components/core/InfoDialog.vue'
import { PURPLE_BG_GRADIENT_TOP } from '@/constants'
import { shareOppCampaignEvents } from '@/segmentAnalytics/opportunities'

@Component({
  components: {
    InfoDialog,
  },
  computed: {
    ...mapGetters(['showShareOpportunityCampaignDialog'])
  }
})
export default class ShareOpportunityCampaignDialog extends Vue {
  contentStyle: string = PURPLE_BG_GRADIENT_TOP

  showShareOpportunityCampaignDialog: boolean

  hideModal () {
    shareOppCampaignEvents.trackClose()
    this.$store.commit('hideShareOpportunityCampaignDialog')
  }

  handleEmailClick () {
    shareOppCampaignEvents.trackEmailClick()
    window.location.href = 'mailto:derek.vanderschyff@riverflex.com'
  }

  handlePostOppClick () {
    shareOppCampaignEvents.trackPostClick()
    this.$emit('postOpp')
  }
}
</script>
